import React, { useState } from "react";
import { Modal } from "react-blueprint-library";
import LostDataModal from "../../../../../../../SharedComponents/LostDataModal";

import "./AddNewMonetarySanctionModal.scss";

const AddNewMonetarySanctionModal = ({
  showAddNewChargeModal,
  setShowAddNewChargeModal,
  isUpdates,
  children,
}) => {
  const [showLDModal, setShowLDModal] = useState(false);

  const handleCloseBackModal = () => {
    setShowLDModal(false);
    setShowAddNewChargeModal(true);
  };

  const handleShowBackModal = () => {
    if (isUpdates) {
      setShowLDModal(true);
    } else {
      setShowAddNewChargeModal(false);
    }
  };

  const handleBackClick = () => {
    handleCloseBackModal();
    setShowAddNewChargeModal(false);
  };

  return (
    <div className="drp-add-new-charge-wrapper">
      <Modal
        show={showAddNewChargeModal}
        className={`modal-md drp-add-new-charge-modal-wrapper ${showLDModal ? "hide-modal" : ""}`}
        title=""
        id="add-new-charge-modal"
      >
        <div className="col-md-1 drp-modal-header-wrapper">
          <h2 id="new-monetary-text">Add New Monetary Sanction</h2>
          <button
            id="add-new-charge-modal-close"
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close modal dialog"
            onClick={handleShowBackModal}
          />
        </div>
        <div className="req-field">
          <span id="required-modal-text">* = Required Field</span>
        </div>
        <div className="req-field-sub" />

        <div className="children-container">
          {React.cloneElement(children, { setShowLDModal: setShowLDModal })}
        </div>
      </Modal>

      <LostDataModal
        isOpen={showLDModal}
        handleClose={handleCloseBackModal}
        handleProceed={handleBackClick}
      />
    </div>
  );
};

export default AddNewMonetarySanctionModal;
